import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2026-05-15T18:00:00-0400.
 */
export function useWorkOrdersPaymentsManagedExternallyEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.WorkOrdersPaymentsManagedExternally,
    false
  );

  return Boolean(isEnabled);
}
